export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previsous"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])},
        "searchResult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search result"])}
      },
      "de": {
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vor"])},
        "searchResult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suchergebnis"])}
      }
    }
  })
}
